import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExpertsService {
  private readonly baseUrl = environment.api.baseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Fetch paginated list of experts with optional filter parameters
   */
  getExperts(params?: {
    page?: number;
    limit?: number;
    search?: string;
    type?: string;
    expertType?: string;
    sort?: string;
  }): Observable<any> {
    let httpParams = new HttpParams();

    if (params) {
      if (params.page !== undefined && params.page !== null) {
        httpParams = httpParams.set('page', params.page.toString());
      }
      if (params.limit !== undefined && params.limit !== null) {
        httpParams = httpParams.set('limit', params.limit.toString());
      }
      if (params.search) {
        httpParams = httpParams.set('search', params.search);
      }
      if (params.type && params.type !== 'all') {
        httpParams = httpParams.set('type', params.type);
      }
      if (params.expertType && params.expertType !== 'all') {
        httpParams = httpParams.set('expertType', params.expertType);
      }
      if (params.sort) {
        httpParams = httpParams.set('sort', params.sort);
      }
    }

    console.log('📡 ExpertsService - Fetching experts with params:', httpParams.toString());
    return this.http.get<any>(`${this.baseUrl}/experts`, { params: httpParams });
  }

  /**
   * Fetch a single expert profile by ID
   */
  getExpertById(id: string): Observable<any> {
    console.log(`📡 ExpertsService - Fetching expert by ID: ${id}`);
    return this.http.get<any>(`${this.baseUrl}/${id}`); // Fixed: id instead of experts/${id} since baseUrl already contains experts or we can just use the new method
  }

  /**
   * Fetch a single expert profile by profileUrl
   */
  getExpertByProfileUrl(profileUrl: string): Observable<any> {
    console.log(`📡 ExpertsService - Fetching expert by profileUrl: ${profileUrl}`);
    return this.http.get<any>(`${this.baseUrl}${profileUrl}`);
  }

  /**
   * Fetch experts stats
   */
  getStats(): Observable<any> {
    console.log('📡 ExpertsService - Fetching experts stats');
    return this.http.get<any>(`${this.baseUrl}/experts/stats`);
  }
}
